
import { Component, Vue } from "vue-property-decorator";
import AdminTable from "@/components/admin/AdminTable.vue";
import AdminSkinCell from "@/components/admin/AdminSkinCell.vue";
import AdminProviderBadge from "@/components/admin/AdminProviderBadge.vue";
import * as _ from "lodash";
import multipleMutate from "@/mixins/multipleMutate";

@Component({
  components: {
    AdminTable,
    AdminSkinCell,
    AdminProviderBadge
  },
  mixins: [multipleMutate]
})
export default class AdminProviderItem extends Vue {
  selected: any[] = [];
  isReserved = false;
  name = "";

  // Вкладки: все предметы (по умолчанию) и по провайдеру
  tabs = [
    {
      name: "all",
      label: "Все",
      icon: "fas fa-layer-group",
      condition: {}
    },
    {
      name: "steam",
      label: "Steam",
      icon: "fab fa-steam",
      condition: { provider: "STEAM" }
    },
    {
      name: "skinify",
      label: "Skinify",
      icon: "fas fa-store",
      condition: { provider: "SKINIFY" }
    },
    {
      name: "skins-back",
      label: "SkinsBack",
      icon: "fas fa-box-open",
      condition: { provider: "SKINS_BACK" }
    }
  ];

  columns = [
    {
      name: "_id",
      required: true,
      label: "name",
      field: "_id",
      align: "left",
      type: "string"
    },
    {
      name: "marketHashName",
      required: true,
      label: "marketHashName",
      field: "marketHashName",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "providerItemId",
      required: true,
      label: "providerItemId",
      field: "providerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "partnerItemId",
      required: true,
      label: "partnerItemId",
      field: "partnerItemId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "provider",
      required: true,
      label: "provider",
      field: "provider",
      align: "center",
      type: "string",
      editable: false
    },
    {
      name: "sellPrice_RUB",
      required: false,
      label: "sellPrice_RUB",
      field: "sellPrice_RUB",
      align: "right",
      sortable: true,
      type: "number"
    },
    {
      name: "buyPrice",
      required: false,
      label: "buyPrice",
      field: "buyPrice",
      align: "right",
      sortable: true,
      type: "number"
    },

    {
      name: "sellPrice",
      required: false,
      label: "sellPrice",
      field: "sellPrice",
      sortable: true,
      align: "right",
      type: "number"
    },
    {
      name: "appId",
      required: true,
      label: "appId",
      field: "appId",
      align: "right",
      type: "number",
      editable: false
    },
    {
      name: "phase",
      required: false,
      sortable: true,
      label: "phase",
      field: "phase",
      align: "left",
      type: "string"
    },
    {
      name: "offerId",
      required: false,
      label: "offerId",
      field: "offerId",
      align: "left",
      type: "string"
    },
    {
      name: "isReserved",
      required: false,
      label: "isReserved",
      field: "isReserved",
      align: "left",
      type: "boolean"
    },
    {
      name: "reservedBySteamId",
      required: false,
      label: "reservedBySteamId",
      field: "reservedBySteamId",
      align: "left",
      type: "string"
    },
    {
      name: "reservedByPartnerUserId",
      required: false,
      label: "reservedByPartnerUserId",
      field: "reservedByPartnerUserId",
      align: "left",
      type: "string"
    },
    {
      name: "reservedPrice_RUB",
      required: false,
      label: "reservedPrice_RUB",
      field: "reservedPrice_RUB",
      align: "left",
      type: "string"
    },
    {
      name: "reservedPrice_USD",
      required: false,
      label: "reservedPrice_USD",
      field: "reservedPrice_USD",
      align: "left",
      type: "string"
    },
    {
      name: "assetId",
      required: true,
      label: "assetId",
      field: "assetId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "botId",
      required: true,
      label: "botId",
      field: "botId",
      align: "left",
      type: "string",
      editable: false
    },
    {
      name: "weapon",
      required: false,
      label: "weapon",
      field: "weapon",
      align: "left",
      type: "string"
    },
    {
      name: "type",
      required: false,
      label: "type",
      field: "type",
      align: "left",
      type: "string"
    },
    {
      name: "rarity",
      required: false,
      label: "rarity",
      field: "rarity",
      align: "left",
      type: "string"
    },
    {
      name: "quality",
      required: false,
      label: "quality",
      field: "quality",
      align: "left",
      type: "string"
    },
    {
      name: "slot",
      required: false,
      label: "slot",
      field: "slot",
      align: "left",
      type: "string"
    },
    {
      name: "hero",
      required: false,
      label: "hero",
      field: "hero",
      align: "left",
      type: "string"
    },
    {
      name: "exterior",
      required: false,
      label: "exterior",
      field: "exterior",
      align: "left",
      type: "string"
    },
    {
      name: "float",
      required: false,
      sortable: true,
      label: "float",
      field: "float",
      align: "left",
      type: "number"
    },
    {
      name: "paintIndex",
      required: false,
      sortable: true,
      label: "paintIndex",
      field: "paintIndex",
      align: "left",
      type: "number"
    },
    {
      name: "paintSeed",
      required: false,
      sortable: true,
      label: "paintSeed",
      field: "paintSeed",
      align: "left",
      type: "number"
    },
    {
      name: "image",
      required: false,
      label: "image",
      field: "image",
      align: "left",
      type: "image"
    },
    {
      name: "reservedAt",
      align: "center",
      label: "reservedAt",
      field: "reservedAt",
      type: "string"
    },
    {
      name: "createdAt",
      align: "center",
      label: "createdAt",
      field: "createdAt",
      type: "string"
    },
    {
      name: "updatedAt",
      align: "center",
      label: "updatedAt",
      field: "updatedAt",
      type: "string"
    }
  ];

  get lastSelected() {
    return _.last(this.selected) || null;
  }
}
